import { ReactElement } from 'react';
import { Link } from 'react-router';
import { KeyboardBackspaceRounded } from '@mui/icons-material';

export interface IPageNav {
  path: string;
  label: string;
}

export const PageNavigation = (props: IPageNav): ReactElement => {
  const { path, label } = props;
  return (
    <div className="page-navigation">
      <Link className="tertiary" to={path}>
        <KeyboardBackspaceRounded className="tertiary-icon-back" />
        {label}
      </Link>
    </div>
  );
};
